import React from 'react';
import './WhyInvest.css';

const WhyInvest = () => {
  const scrollToForm = () => {
    const formSection = document.getElementById('contact');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const realEstateBenefits = [
    {
      icon: '📈',
      title: 'Tangible Asset',
      description: 'Real estate is a physical asset that you can see, touch, and control. Unlike stocks or bonds, property provides real value and security.'
    },
    {
      icon: '💰',
      title: 'Wealth Building',
      description: 'Property values historically appreciate over time, building long-term wealth while providing rental income opportunities.'
    },
    {
      icon: '🛡️',
      title: 'Portfolio Diversification',
      description: 'Real estate offers a hedge against inflation and market volatility, diversifying your investment portfolio effectively.'
    },
    {
      icon: '🏠',
      title: 'Passive Income',
      description: 'Generate steady rental income while your property appreciates in value, creating multiple revenue streams.'
    },
    {
      icon: '📊',
      title: 'Tax Advantages',
      description: 'Benefit from various tax deductions, depreciation, and capital gains advantages that come with property ownership.'
    },
    {
      icon: '🌍',
      title: 'Global Opportunity',
      description: 'Invest in prime locations worldwide, from Nigeria to the USA, expanding your investment horizons.'
    }
  ];

  const chalcedonyAdvantages = [
    {
      icon: '✨',
      title: 'Premium Locations',
      description: 'Strategically located in Umuahia, Abia State with fast access to key landmarks and thriving infrastructure.'
    },
    {
      icon: '🏗️',
      title: 'Smart City Technology',
      description: 'Our estates feature cutting-edge smart city infrastructure, making them future-ready and highly desirable.'
    },
    {
      icon: '🌱',
      title: 'Green & Sustainable',
      description: 'Eco-friendly developments with green spaces, sustainable practices, and modern amenities that attract quality tenants.'
    },
    {
      icon: '🔒',
      title: 'Secure Investment',
      description: 'All properties come with proper titles (R of O, Governor Consent) ensuring legal security and peace of mind.'
    },
    {
      icon: '💎',
      title: 'Proven Track Record',
      description: 'Chalcedony Estate has a strong reputation for delivering quality developments that appreciate in value over time.'
    },
    {
      icon: '🎯',
      title: 'Flexible Payment Plans',
      description: 'Multiple payment options including outright purchase and flexible installment plans to suit your budget.'
    }
  ];

  return (
    <section className="why-invest-section section">
      <div className="container">
        <div className="why-invest-header">
          <h2 className="section-title">Why Invest in Real Estate?</h2>
          <p className="section-subtitle">
            Real estate remains one of the most reliable and profitable investment vehicles available today
          </p>
        </div>

        <div className="benefits-grid">
          {realEstateBenefits.map((benefit, index) => (
            <div key={index} className="benefit-card">
              <div className="benefit-icon">{benefit.icon}</div>
              <h3 className="benefit-title">{benefit.title}</h3>
              <p className="benefit-description">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="why-garnet-section">
          <div className="garnet-header">
            <h2 className="section-title">Why Choose Chalcedony Estate?</h2>
            <p className="section-subtitle">
              We don't just sell properties - we create investment opportunities that grow with you
            </p>
          </div>

          <div className="advantages-grid">
            {chalcedonyAdvantages.map((advantage, index) => (
              <div key={index} className="advantage-card">
                <div className="advantage-icon">{advantage.icon}</div>
                <h3 className="advantage-title">{advantage.title}</h3>
                <p className="advantage-description">{advantage.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="cta-section">
          <div className="cta-content">
            <h2 className="cta-title">Ready to Start Your Investment Journey?</h2>
            <p className="cta-subtitle">
              Join hundreds of smart investors who have chosen Chalcedony Estate for their real estate portfolio
            </p>
            <button 
              className="cta-button btn btn-primary"
              onClick={scrollToForm}
            >
              Get Started Now
              <span className="cta-arrow">→</span>
            </button>
            <p className="cta-note">Fill out our form and our team will contact you within 24 hours</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyInvest;


